import type { BrandTestimonialDefinition } from "~/business-areas/brand/brand.model";

export function useTestimonialList() {
  const query = useLazyFetch("/api/testimonials", {
    transform(data): BrandTestimonialDefinition[] {
      return (
        data?.map((item) => {
          return {
            id: item.author,
            authorFullName: item.author,
            authorAvatar: item.author_avatar,
            authorJob: item.author_job_title,
            authorCompanyLogo: item.author_company_logo,
            authorCompanyName: item.author_company,
            content: item.content,
            rating: item.rating,
            paths: item.paths,
          };
        }) ?? []
      );
    },
    default: () => [] as BrandTestimonialDefinition[],
  });

  const route = useRoute();

  return {
    ...query,
    data: computed(() => {
      return (
        query.data.value?.filter((entry) => {
          const exclusions =
            entry.paths?.filter((path) => path.startsWith("!")) ?? [];
          const hasAtLeastOneMatch = !!entry.paths?.some((path) =>
            isMatchingPath(route.path, path),
          );
          const isNotExcluded = exclusions.every((exclusion) =>
            isMatchingPath(route.path, exclusion),
          );

          return hasAtLeastOneMatch && isNotExcluded;
        }) ?? []
      );
    }),
  };
}
